export default Object.freeze({
  FormField: 1,
  Variable: 2,
  InstanceName: 3,
  OperationObservations: 4,
  OperationUserEmail: 5,
  OperationIsApprovalOrReject: 6,
});
